import { css } from 'styled-components'
import { getFontWeight } from './lib'

const bigTitle = css`
	font-size: 64px;
	line-height: 110%;
`

const head1 = css`
	font-size: 34px;
	line-height: 110%;
`

const head2 = css`
	font-size: 27px;
	line-height: 120%;
`

const head3 = css`
	font-size: 22px;
	line-height: 132%;
`

const head4 = css`
	font-size: 16px;
	line-height: 150%;
`

const body = css`
	font-size: 16px;
	line-height: 150%;
`

const subheadline = css`
	font-size: 14px;
	line-height: 150%;
`

const footnote = css`
	font-size: 13px;
	line-height: 162%;
`

const caption = css`
	font-size: 12px;
	line-height: 150%;
`

const overline = css`
	font-size: 11px;
	line-height: 164%;
`

const u16 = css`
	font-size: 16px;
	line-height: 150%;
	text-decoration-line: underline;
`
const u14 = css`
	font-size: 14px;
	line-height: 150%;
	text-decoration-line: underline;
`
const s16 = css`
	font-size: 16px;
	line-height: 150%;
	text-decoration-line: line-through;
`
const s14 = css`
	font-size: 14px;
	line-height: 150%;
	text-decoration-line: line-through;
`

const m12 = css`
	font-family: 'JetBrains Mono', monospace;
	font-size: 12px;
	line-height: 18px;
`

const m14 = css`
	font-family: 'JetBrains Mono', monospace;
	font-size: 14px;
	line-height: 21px;
`

const m16 = css`
	font-family: 'JetBrains Mono', monospace;
	font-size: 16px;
	line-height: 24px;
`

export const typography = {
	bigTitle: css`
		${bigTitle} font-weight: ${getFontWeight(800)};
	`,
	head1: {
		bold: css`
			${head1} font-weight: ${getFontWeight(800)};
		`,
		regular: css`
			${head1} font-weight: ${getFontWeight(400)};
		`,
	},
	head2: {
		bold: css`
			${head2} font-weight: ${getFontWeight(800)};
		`,
		regular: css`
			${head2} font-weight: ${getFontWeight(400)};
		`,
	},
	head3: {
		bold: css`
			${head3} font-weight: ${getFontWeight(800)};
		`,
		semiBold: css`
			${head3} font-weight: ${getFontWeight(600)};
		`,
		regular: css`
			${head3} font-weight: ${getFontWeight(400)};
		`,
	},
	head4: {
		bold: css`
			${head4} font-weight: ${getFontWeight(800)};
		`,
	},
	body: {
		bold: css`
			${body} font-weight: ${getFontWeight(800)};
		`,
		medium: css`
			${body} font-weight: ${getFontWeight(500)};
		`,
		regular: css`
			${body} font-weight: ${getFontWeight(400)};
		`,
		light: css`
			${body} font-weight: ${getFontWeight(300)};
		`,
	},
	subheadline: {
		bold: css`
			${subheadline} font-weight: ${getFontWeight(700)};
		`,
		medium: css`
			${subheadline} font-weight: ${getFontWeight(500)};
		`,
		regular: css`
			${subheadline} font-weight: ${getFontWeight(400)};
		`,
		light: css`
			${subheadline} font-weight: ${getFontWeight(300)};
		`,
	},
	footnote: {
		medium: css`
			${footnote} font-weight: ${getFontWeight(600)};
		`,
		regular: css`
			${footnote} font-weight: ${getFontWeight(400)};
		`,
	},
	caption: {
		bold: css`
			${caption} font-weight: ${getFontWeight(800)};
		`,
		medium: css`
			${caption} font-weight: ${getFontWeight(500)};
		`,
		regular: css`
			${caption} font-weight: ${getFontWeight(400)};
		`,
		light: css`
			${caption} font-weight: ${getFontWeight(300)};
		`,
	},
	overline: {
		regular: css`
			${overline} font-weight: ${getFontWeight(400)};
		`,
	},
	u16: {
		bold: css`
			${u16} font-weight: ${getFontWeight(700)};
		`,
		regular: css`
			${u16} font-weight: ${getFontWeight(400)};
		`,
	},
	u14: {
		regular: css`
			${u14} font-weight: ${getFontWeight(400)};
		`,
	},
	s16: {
		regular: css`
			${s16} font-weight: ${getFontWeight(400)};
		`,
	},
	s14: {
		regular: css`
			${s14} font-weight: ${getFontWeight(400)};
		`,
	},

	m12: {
		light: css`
			${m12} font-weight: ${getFontWeight(300)};
		`,
		regular: css`
			${m12} font-weight: ${getFontWeight(400)};
		`,
	},

	m14: {
		medium: css`
			${m14} font-weight: ${getFontWeight(500)};
		`,
		bold: css`
			${m14} font-weight: ${getFontWeight(800)};
		`,
	},

	m16: {
		medium: css`
			${m16} font-weight: ${getFontWeight(500)};
		`,
		bold: css`
			${m16} font-weight: ${getFontWeight(800)};
		`,
	},
}
